import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const appStoreButtonsStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: { xs: 'column', s: 'row' },
		alignItems: 'center',
		columnGap: { xs: '16px', s: '24px' },
		rowGap: { xs: '5px', sm: '16px' },

		'& > *': {
			cursor: 'pointer',
		},
	},
	storeButton: {
		width: { xs: '135px', md: '210px' },
		height: { xs: '56px', md: '72px' },

		'& .onHover': {
			fill: 'white',
			transition: 'all 0.3s ease',
		},

		'&:hover .onHover': {
			fill: Colors['FFF521'],
		},
	},
});
